"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuiSingular = exports.GuiShowAnyOption = exports.GuiSearchFunctionDelay = exports.GuiSearchFunction = exports.GuiSearchFrom = exports.GuiSearchAfter = exports.GuiSearchable = exports.GuiRange = exports.GuiProperties = exports.GuiPlural = exports.GuiPlaceholder = exports.GuiOrdering = exports.GuiOrder = exports.GuiOptionLabel = exports.GuiOptionKey = exports.GuiOptionGroup = exports.GuiName = exports.GuiMulti = exports.GuiMethod = exports.GuiMain = exports.GuiLabelMode = exports.GuiLabelCustomID = exports.GuiLabel = exports.GuiInnerHits = exports.GuiInclude = exports.GuiHits = exports.GuiGroups = exports.GuiFrom = exports.GuiFields = exports.GuiField = exports.GuiExclude = exports.GuiEditable = exports.GuiDisabledLabel = exports.GuiDisabled = exports.GuiDefaultValues = exports.GuiContainer = exports.GuiCondition = exports.GuiCollapse = exports.GuiBoost = exports.GuiBind = exports.GuiBare = exports.GuiApplyOn = exports.GuiAnyOptionLabel = exports.GuiAllowEmptyValues = exports.GuiAggregations = exports.Gui = exports._type = exports._id = exports.CustomID = exports._context = void 0;
exports.SEARCH_QUERY_FIELDS = exports.SEARCH_QUERY_TERM = exports.SEARCH_SIZE = exports.SEARCH_SORT = exports.SEARCH_AGGREGATIONS = exports.SEARCH_COLLAPSE = exports.SEARCH_SOURCE = exports.SEARCH_FROM = exports.SEARCH_FILTERS = exports.SEARCH_QUERY = exports.AGGREGATION_EXCLUDE_SUFFIX = exports.AGGREGATION_INCLUDE_SUFFIX = exports.AGGREGATION_TERM_SUFFIX = exports.AGGREGATION_FIELD_SUFFIX = exports.FIELDS_PARAMETER = exports.SEARCH_ANY_OPTION_KEY = exports.SEARCH_ENDPOINT = exports.ACCEPT_ENCODING_HEADER = exports.ACCEPT_HEADER = exports.CONTENT_TYPE_HEADER = exports.X_RESPONSE_VERSION_HEADER = exports.X_SEARCH_ID_HEADER = exports.STREAMJSON_CONTENT_TYPE = exports.LDJSON_CONTENT_TYPE = exports.JSON_CONTENT_TYPE = exports.SEARCH_DEFAULT_OPERATOR = exports.SEARCH_DEFAULT_METHOD = exports.SEARCH_DEFAULT_STREAMED = exports.SEARCH_METHOD_OPEN = exports.SEARCH_METHOD_POST = exports.SEARCH_METHOD_GET = exports.Xsd = exports.Value = exports.Type = exports.Query = exports.Placeholder = exports.HandleSearch = exports.HandleClear = exports.HandleQueryChange = exports.GuiVisible = exports.GuiValues = exports.GuiValue = exports.GuiVariable = exports.GuiTarget = exports.GuiType = exports.GuiTerm = exports.GuiStreamed = exports.GuiSource = exports.GuiSort = exports.GuiSize = void 0;
exports.SEARCH_AGGREGATION_SIZE = exports.SEARCH_AGGREGATION_EXCLUDE = exports.SEARCH_AGGREGATION_INCLUDE = exports.SEARCH_AGGREGATION_TYPE = exports.SEARCH_AGGREGATION_TERM = exports.SEARCH_AGGREGATION_FIELD = exports.SEARCH_AGGREGATION_NAME = exports.SEARCH_SORT_SEARCH_AFTER = exports.SEARCH_SORT_DIRECTION = exports.SEARCH_SORT_FIELD = exports.SEARCH_COLLAPSE_INNER_HITS_SOURCE = exports.SEARCH_COLLAPSE_INNER_HITS_SORT = exports.SEARCH_COLLAPSE_INNER_HITS_SIZE = exports.SEARCH_COLLAPSE_INNER_HITS_NAME = exports.SEARCH_COLLAPSE_INNER_HITS = exports.SEARCH_COLLAPSE_FIELD = exports.SEARCH_FILTERS_OPERATOR = exports.SEARCH_FILTERS_VALUES = exports.SEARCH_FILTERS_FIELD = exports.SEARCH_FIELDS_BOOST = exports.SEARCH_FIELDS_FIELD = void 0;
exports._context = '@context';
exports.CustomID = 'customID';
exports._id = '@id';
exports._type = '@type';
exports.Gui = 'gui';
exports.GuiAggregations = 'gui:aggregations';
exports.GuiAllowEmptyValues = 'gui:allowEmptyValues';
exports.GuiAnyOptionLabel = 'gui:anyOptionLabel';
exports.GuiApplyOn = 'gui:applyOn';
exports.GuiBare = 'gui:bare';
exports.GuiBind = 'gui:bind';
exports.GuiBoost = 'gui:boost';
exports.GuiCollapse = 'gui:collapse';
exports.GuiCondition = 'gui:condition';
exports.GuiContainer = 'gui:container';
exports.GuiDefaultValues = 'gui:defaultValues';
exports.GuiDisabled = 'gui:disabled';
exports.GuiDisabledLabel = 'gui:disabledLabel';
exports.GuiEditable = 'gui:editable';
exports.GuiExclude = 'gui:exclude';
exports.GuiField = 'gui:field';
exports.GuiFields = 'gui:fields';
exports.GuiFrom = 'gui:from';
exports.GuiGroups = 'gui:groups';
exports.GuiHits = 'gui:hits';
exports.GuiInclude = 'gui:include';
exports.GuiInnerHits = 'gui:inner_hits';
exports.GuiLabel = 'gui:label';
exports.GuiLabelCustomID = 'gui:labelCustomID';
exports.GuiLabelMode = 'gui:labelMode';
exports.GuiMain = 'gui:main';
exports.GuiMethod = 'gui:method';
exports.GuiMulti = 'gui:multi';
exports.GuiName = 'gui:name';
exports.GuiOptionGroup = 'g';
exports.GuiOptionKey = 'k';
exports.GuiOptionLabel = 'l';
exports.GuiOrder = 'gui:order';
exports.GuiOrdering = 'gui:ordering';
exports.GuiPlaceholder = 'gui:placeholder';
exports.GuiPlural = 'gui:plural';
exports.GuiProperties = 'gui:properties';
exports.GuiRange = 'gui:range';
exports.GuiSearchable = 'gui:searchable';
exports.GuiSearchAfter = 'gui:searchAfter';
exports.GuiSearchFrom = 'gui:searchFrom';
exports.GuiSearchFunction = 'gui:searchFunction';
exports.GuiSearchFunctionDelay = 'gui:searchFunctionDelay';
exports.GuiShowAnyOption = 'gui:showAnyOption';
exports.GuiSingular = 'gui:singular';
exports.GuiSize = 'gui:size';
exports.GuiSort = 'gui:sort';
exports.GuiSource = 'gui:source';
exports.GuiStreamed = 'gui:streamed';
exports.GuiTerm = 'gui:term';
exports.GuiType = 'gui:type';
exports.GuiTarget = 'gui:target';
exports.GuiVariable = 'gui:variable';
exports.GuiValue = 'gui:value';
exports.GuiValues = 'gui:values';
exports.GuiVisible = 'gui:visible';
exports.HandleQueryChange = 'handleQueryChange';
exports.HandleClear = 'handleClear';
exports.HandleSearch = 'handleSearch';
exports.Placeholder = 'placeholder';
exports.Query = 'query';
exports.Type = 'type';
exports.Value = 'value';
exports.Xsd = 'xsd';
/*** Search Method Constants ***/
exports.SEARCH_METHOD_GET = 'GET';
exports.SEARCH_METHOD_POST = 'POST';
exports.SEARCH_METHOD_OPEN = 'OPEN';
/*** Search Constants ***/
exports.SEARCH_DEFAULT_STREAMED = false;
exports.SEARCH_DEFAULT_METHOD = 'GET';
exports.SEARCH_DEFAULT_OPERATOR = 'OR';
/*** Content Types ***/
exports.JSON_CONTENT_TYPE = 'application/json';
exports.LDJSON_CONTENT_TYPE = 'application/ld+json';
exports.STREAMJSON_CONTENT_TYPE = 'application/stream+json';
/*** Headers ***/
exports.X_SEARCH_ID_HEADER = 'x-search-id';
exports.X_RESPONSE_VERSION_HEADER = 'X-Response-Version';
exports.CONTENT_TYPE_HEADER = 'Content-Type';
exports.ACCEPT_HEADER = 'Accept';
exports.ACCEPT_ENCODING_HEADER = 'Accept-Encoding';
/*** Search URL Constants ***/
exports.SEARCH_ENDPOINT = '_search';
exports.SEARCH_ANY_OPTION_KEY = '_any';
exports.FIELDS_PARAMETER = '_fields';
exports.AGGREGATION_FIELD_SUFFIX = '_f';
exports.AGGREGATION_TERM_SUFFIX = '_t';
exports.AGGREGATION_INCLUDE_SUFFIX = '_i';
exports.AGGREGATION_EXCLUDE_SUFFIX = '_e';
/*** Search Body Constants ***/
exports.SEARCH_QUERY = '_query';
exports.SEARCH_FILTERS = '_filters';
exports.SEARCH_FROM = '_from';
exports.SEARCH_SOURCE = '_source';
exports.SEARCH_COLLAPSE = '_collapse';
exports.SEARCH_AGGREGATIONS = '_aggregations';
exports.SEARCH_SORT = '_sort';
exports.SEARCH_SIZE = '_size';
exports.SEARCH_QUERY_TERM = 'term';
exports.SEARCH_QUERY_FIELDS = 'fields';
exports.SEARCH_FIELDS_FIELD = 'field';
exports.SEARCH_FIELDS_BOOST = 'boost';
exports.SEARCH_FILTERS_FIELD = 'field';
exports.SEARCH_FILTERS_VALUES = 'values';
exports.SEARCH_FILTERS_OPERATOR = 'operator';
exports.SEARCH_COLLAPSE_FIELD = 'field';
exports.SEARCH_COLLAPSE_INNER_HITS = 'innerHits';
exports.SEARCH_COLLAPSE_INNER_HITS_NAME = 'name';
exports.SEARCH_COLLAPSE_INNER_HITS_SIZE = 'size';
exports.SEARCH_COLLAPSE_INNER_HITS_SORT = 'sort';
exports.SEARCH_COLLAPSE_INNER_HITS_SOURCE = 'source';
exports.SEARCH_SORT_FIELD = 'field';
exports.SEARCH_SORT_DIRECTION = 'direction';
exports.SEARCH_SORT_SEARCH_AFTER = 'search_after';
exports.SEARCH_AGGREGATION_NAME = 'name';
exports.SEARCH_AGGREGATION_FIELD = 'field';
exports.SEARCH_AGGREGATION_TERM = 'term';
exports.SEARCH_AGGREGATION_TYPE = 'type';
exports.SEARCH_AGGREGATION_INCLUDE = 'include';
exports.SEARCH_AGGREGATION_EXCLUDE = 'exclude';
exports.SEARCH_AGGREGATION_SIZE = 'size';
